import {Component, EventEmitter, forwardRef, Input, OnChanges, Output, SimpleChanges} from '@angular/core';
import {ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR} from '@angular/forms';
import {MatCheckboxChange} from '@angular/material/checkbox';

@Component({
  selector: 'app-element-checkbox',
  templateUrl: './element-checkbox.component.html',
  styleUrls: [],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ElementCheckboxComponent),
      multi: true,
    },
  ],
})
export class ElementCheckboxComponent implements OnChanges, ControlValueAccessor {

  formControl: FormControl = new FormControl();
  @Input() qaAttr: string;
  @Input() label = 'default label';
  @Input() defaultValue = false;
  @Input() labelPosition: 'before' | 'after' = 'after';
  @Input() disabled = false;
  @Output() control: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() valueChanged: EventEmitter<boolean> = new EventEmitter<boolean>();

  onChange: (value: any) => void = () => {};
  onTouched: () => void = () => {};

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.label && changes.label.currentValue) {
      const value = changes.label.currentValue || 'qa-checkbox';
      this.qaAttr = 'qa-' + value.replace(/ /g, '-').toLowerCase();
    }
    if (changes.defaultValue && changes.defaultValue.currentValue) {
      this.formControl.setValue(this.defaultValue);
    }
  }


  writeValue(value: any): void {
    this.formControl.setValue(value);
  }


  registerOnChange(onChange: (value: any) => void): void {
    this.onChange = onChange;
  }

  registerOnTouched(onTouched: () => void): void {
    this.onTouched = onTouched;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
    isDisabled ? this.formControl.disable() : this.formControl.enable();
  }

  onMatCheckboxChange($event: MatCheckboxChange): void {
    const checked: boolean = $event?.checked;
    this.onChange(checked);
    this.onTouched();
  }

}
